// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { parseProductCategories } from "@guestsupply/XDL/Utilities";
import { addToEndOfChain, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { UpdateCartLineApiParameter } from "@insite/client-framework/Services/CartService";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain as UpdateCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateCartLineParameter {
    onSuccess?: () => void;
    cartLine: CartLineModel;
    shouldNotReloadPromotions?: boolean;
    shouldNotLoadFullCart?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter>;

export const XngGaUpdateCartLine: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentBillTo = getCurrentBillToState(state).value;
    const currentlyUpdatedCartLine = props.parameter.cartLine;
    const cart = getCurrentCartState(props.getState()).value;
    const cartLineBeforeUpdate = cart?.cartLines?.find(cartLine => cartLine.line === currentlyUpdatedCartLine.line);

    if (state.xGoogleAnalytics.includeAddToCartEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.UPDATE_CART,
            quantity: Number(currentlyUpdatedCartLine.qtyOrdered) - Number(cartLineBeforeUpdate?.qtyOrdered),
            item_name: currentlyUpdatedCartLine.shortDescription,
            item_id: currentlyUpdatedCartLine.erpNumber,
            item_brand: currentlyUpdatedCartLine.brand?.name,
            brand_code: currentBillTo?.properties?.brand,
            exclusive: currentBillTo?.properties?.exclusive,
            group_descr: currentBillTo?.properties?.groupDescription,
            affiliation: currentBillTo?.companyName,
            ...parseProductCategories(currentlyUpdatedCartLine?.properties?.categories),
        };

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push(googleAnalyticsData);
    }
};

const _GaUpdateProductToCart = XngGaUpdateCartLine as any;
addToEndOfChain(UpdateCartLine, _GaUpdateProductToCart);
